import { assertServiceHost, axiosClient } from '@nx-frontend/shared/api';
import { SubscriptionDto, subscriptionFromDto } from '@nx-frontend/shared/types';

interface UpdateSubscriptionAddonsParams {
  host: string;
  userId: number;
  subscriptionId: string;
  /**
   * Secret for accessing internal services, not a super secret
   */
  secret: string;
}

interface UpdateSubscriptionAddonsData {
  /**
   * addon code
   */
  code: string;
  /**
   * addon price
   */
  price: number;
  /**
   * addon quantity
   */
  quantity: number;
}

export async function updateSubscriptionAddons(
  params: UpdateSubscriptionAddonsParams,
  data: UpdateSubscriptionAddonsData
) {
  const { host, userId, subscriptionId, secret } = params;
  const response = await axiosClient.post<SubscriptionDto>(
    `${assertServiceHost(host)}/v1/subscriptions/${encodeURIComponent(subscriptionId)}/addons`,
    data,
    { userId, secret }
  );
  return subscriptionFromDto(response.data);
}
